export default __webpack_public_path__ + "static/media/logo-bookmark-pro.d158ca63.svg";